import PropTypes from "prop-types";
import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";

const DeleteModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  loading = false,
}) => {
  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalHeader toggle={onCloseClick}>
        <i
          className="ri-delete-bin-fill"
          style={{ color: "#FB0000", fontSize: "25px" }}
        />
      </ModalHeader>
      <ModalBody className="mb-0 mb-md-4">
        <div className="">
          <p className="deleteConfirmText">Delete Confirmation</p>
          <span className="deleteTitle">Are You Sure Want To Delete?</span>
        </div>
      </ModalBody>
      <ModalFooter className="w-100 p-0">
        <div className="col-12 d-flex m-0">
          <div className="col-6">
            <Button
              className="updateProfileClose"
              color="warning"
              onClick={onCloseClick}
            >
              Cancel
            </Button>
          </div>
          <div className="col-6">
            <Button
              disabled={loading}
              color="danger"
              className="modalDeleteButton"
              onClick={() => {
                onDeleteClick();
              }}
            >
              {loading ? <Spinner /> : "Delete"}
            </Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
};

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
};

export default DeleteModal;
